/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClaimRoutingModule} from './claim-routing.module';
import {ClaimCreateNewModule} from './claim-create-new/claim-create-new.module';
import {ClaimMainPageModule} from './claim-main-page/claim-main-page.module';
import {TooltipModule} from '../shared/tooltip/tooltip.module';
import {ClaimDetailPageModule} from './claim-detail-page/claim-detail-page.module';
import {ClaimEditPageModule} from './claim-edit-page/claim-edit-page.module';
import {ClaimAttachmentsPageModule} from './claim-attachments-page/claim-attachments-page.module';

@NgModule({
    imports: [
        CommonModule,
        ClaimRoutingModule,
        ClaimCreateNewModule,
        ClaimMainPageModule,
        ClaimDetailPageModule,
        ClaimEditPageModule,
        ClaimAttachmentsPageModule,
        TooltipModule
    ]
})
export class ClaimModule {
}
